import { useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'

import Tooltip from '@material-ui/core/Tooltip'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

// Splits an attribution string and turns URLs (with or without protocol) into links.
const URL_PART = /((?:https?:\/\/)?[a-z0-9.-]+\.[a-z]{2,}\/[^\s,;]*[^\s,;.])/g
const URL_TEST = /^(?:https?:\/\/)?[a-z0-9.-]+\.[a-z]{2,}\/[^\s]*$/i

const renderAttributionText = (text) =>
    text.split(URL_PART).map((part, index) =>
        URL_TEST.test(part) ? (
            <a
                key={index}
                href={part.startsWith('http') ? part : `https://${part}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
            >
                {part}
            </a>
        ) : (
            part
        )
    )

const LayerTooltip = ({ layer, marginLeft }) => {
    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 320,
            fontSize: theme.typography.pxToRem(14),
            border: '1px solid #dadde9',
            marginLeft: theme.spacing(marginLeft || 30),
            padding: theme.spacing(1, 1.5),
            lineHeight: 1.5,
        },
    }))(Tooltip)
    const { t, i18n } = useTranslation()

    const attributionKey = `layer_attribution.${layer?.name}`
    const hasAttribution = i18n.exists(attributionKey)

    return (
        <HtmlTooltip
            interactive
            title={
                <>
                    {t(`layer_description.${layer?.name}`)}
                    {hasAttribution && (
                        <div
                            style={{
                                marginTop: 6,
                                paddingTop: 6,
                                borderTop: '1px solid #e0e0e0',
                                fontSize: '0.85em',
                                color: 'rgba(0, 0, 0, 0.6)',
                            }}
                        >
                            {renderAttributionText(t(attributionKey))}
                        </div>
                    )}
                </>
            }
            placement="right-end"
        >
            <InfoOutlinedIcon color="primary" style={{ fontSize: 18, cursor: 'help' }} />
        </HtmlTooltip>
    )
}

export default LayerTooltip
